import { demoResponses, fallbackResponse } from '@/mocks/ai';

export interface ChatMessage {
  id: string;
  role: 'user' | 'assistant';
  content: string;
  timestamp: string;
}

/**
 * Mode démo : renvoie une réponse simulée en fonction du contenu du message.
 * Quand une clé IA (OpenAI/Anthropic) sera configurée dans un Edge Function,
 * cette fonction sera remplacée par un vrai appel `supabase.functions.invoke('ai-chat')`.
 */
export function getDemoReply(prompt: string): string {
  const q = prompt.toLowerCase();
  const match = demoResponses.find((d) => d.keywords.some((k) => q.includes(k)));
  return match ? match.response : fallbackResponse;
}

export function generateId(): string {
  return `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
}